import { render, staticRenderFns } from "./app-detail-recommend-selection.vue?vue&type=template&id=1bedfa7a&scoped=true&"
import script from "./app-detail-recommend-selection.vue?vue&type=script&lang=js&"
export * from "./app-detail-recommend-selection.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-recommend-selection.vue?vue&type=style&index=0&id=1bedfa7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bedfa7a",
  null
  
)

export default component.exports